import PropTypes from 'prop-types';
import React from 'react';
import { FiCheck } from 'react-icons/fi';
import * as Ui from './SelectionIndicator.styles';

const SelectionIndicator = ({ selected = false, ...props }) => (
  <Ui.Indicator $selected={selected} aria-hidden="true" {...props}>
    {selected && <FiCheck size={18} strokeWidth={3} />}
  </Ui.Indicator>
);

SelectionIndicator.propTypes = {
  selected: PropTypes.bool,
};

export default SelectionIndicator;
